module.exports = __webpack_public_path__ + "img/N2 200X200.ef367a41.png";